import { Breadcrumb } from 'components/breadcrumb'
import { PecSwitch, PrivateRoute } from 'components/route'
import { ATENDIMENTO_NOVO_ENABLED, ATENDIMENTO_VACINACAO_ENABLED } from 'config/flags'
import { useRouter } from 'hooks/useRouter'
import React from 'react'
import Permissions from 'types/Permissions'
import AtendimentoEsusView from 'view/atendimentos/esus/AtendimentoEsusView'
import AtendimentoVacincacaoEsusView from 'view/atendimentos/esus/AtendimentoVacincacaoEsusView'
import EscutaInicialEsusView from 'view/atendimentos/esus/EscutaInicialEsusView'
import { ListaAtendimentoRootView } from 'view/atendimentos/ListaAtendimentoRootView'

import { AtendimentoView } from './detail/AtendimentoView'

export function AtendimentoRootView() {
  const { match } = useRouter()
  return (
    <>
      <Breadcrumb title='Lista de atendimentos' />

      <PecSwitch>
        <PrivateRoute
          path={`${match.url}/atendimento/visualizarProntuario/:atendimentoId`}
          component={AtendimentoEsusView}
          permission={Permissions.visualizarProntuario}
        />
        <PrivateRoute
          path={`${match.url}/atendimento/:atendimentoId`}
          component={AtendimentoEsusView}
          permission={Permissions.visualizarListaDeAtendimento.atender}
        />
        {(ATENDIMENTO_NOVO_ENABLED || ATENDIMENTO_VACINACAO_ENABLED) && (
          <PrivateRoute
            path={`${match.url}/next/:atendimentoId`}
            component={AtendimentoView}
            permission={Permissions.visualizarListaDeAtendimento.atender}
          />
        )}
        <PrivateRoute
          exact
          path={`${match.url}/escuta/:atendimentoId`}
          component={EscutaInicialEsusView}
          permission={Permissions.visualizarListaDeAtendimento.visualizarEscutaInicial.realizarEscutaInicial}
        />
        <PrivateRoute
          exact
          path={`${match.url}/atendimentoVacinacao/:atendimentoId`}
          component={AtendimentoVacincacaoEsusView}
          permission={Permissions.visualizarListaDeAtendimento.atender.realizarAtendimentoDeVacinacao}
        />
        <PrivateRoute
          path={`${match.url}`}
          component={ListaAtendimentoRootView}
          permission={Permissions.visualizarListaDeAtendimento}
        />
      </PecSwitch>
    </>
  )
}
